import { useEffect, useState } from 'react';
import type { Category } from '@shopgnd/shared';
import { listCategories } from '@/api/categories';
import { subscribeCatalogRefresh } from '@/lib/catalog-refresh';

const CACHE_KEY = 'shopgnd-categories-v1';

function readCachedCategories(): Category[] {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Category[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeCachedCategories(categories: Category[]): void {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(categories));
  } catch {
    /* quota / private mode */
  }
}

/** Warm category list for home tiles and nav (non-blocking). */
export function prefetchCategories(): void {
  void listCategories().then((categories) => {
    if (categories.length > 0) writeCachedCategories(categories);
  });
}

export function useCategories(): Category[] {
  const [categories, setCategories] = useState<Category[]>(() => readCachedCategories());

  useEffect(() => {
    const load = () => {
      void listCategories().then((next) => {
        setCategories(next);
        if (next.length > 0) writeCachedCategories(next);
      });
    };
    load();
    return subscribeCatalogRefresh(load);
  }, []);

  return categories;
}
